// Module
var code = "<div class=\"progress-bar\"> <label> <slot name=\"label\"> <span>{{ Math.floor(100 * progress / max) }}%</span> </slot> <template v-if=\"progress\"> <progress :max=\"max\" :value=\"progress\"></progress> </template> <template v-else> <progress :max=\"max\"></progress> </template> </label> </div>";
// Exports
module.exports = code;